import Header from "../../Window/Header";
import Lottie from "lottie-react";
import groovyWalkAnimation from "./anim.json";
import ticketJump from "./anim-ticket.json";
import Localized from "../../../Localized";

import { saveAs } from 'file-saver';

import './style.scss';
//import wallet from '../../../img/finalStep/add-to-wallet-btn.png';
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { changeStep } from "../../../redux/slices/windowSlice";

const FinalStep = () => {
    
    const [ url, setUrl ] = useState<Blob | null>(null);

    const dispatch = useAppDispatch();
    dispatch(changeStep(4));

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    let emailUrl = searchParams.get("email");
    let token = searchParams.get("token");

    useEffect(() => {        
          axios({
            method: 'get',
            url: 'https://ticketok.by/api/ticket/get.php?token=' + token,
            responseType: 'arraybuffer'
          })
          .then(function (response) {
            setUrl(new Blob([response.data], {type: 'application/pdf'}));
          })
          .catch(function (error) {
            console.log(error);
          });
    }, [token]);

    const handleDownload = () => {
        if (!url) return;
        saveAs(url, 'ticket.pdf');
    };



    return (
        <div className="modal">
            <Header />
            <div className="order-mode final">
                <div className="final_container">
                    <div className="final_wrapper">
                        <div className="final_animate">
                            <div className="final_animate_file">
                                <Lottie animationData={ticketJump} loop={true} />
                            </div>
                        </div>
                        <h1 className="final_title">{Localized.FinalThankYou}</h1>
                        <h2 className="final_text">
                            {Localized.formatString(Localized.FinalText, {
                                email: <b>{emailUrl}</b>
                            })}</h2>
                            {url && (
                                <div className="final_btns">
                                <div className="final_btns_ticket" onClick={() => handleDownload()}>
                                    <span className="final_btns_ticket_text">{Localized.FinalDownloadTicket}</span>
                                </div>
                                {/* <div className="final_btns_invoice">
                                    <span className="final_btns_invoice_text">{Localized.FinalDownloadInvoice}</span>
                                </div> */}
                            </div>
                            )}
                    </div>
                </div>
            </div>
            <div className="anim">
                <Lottie animationData={groovyWalkAnimation} loop={false} />
            </div>
        </div>
        
    );
}

export default FinalStep;